import React, { Component } from 'react';
import { Table, Button, Card, Modal, Form, Input, Popconfirm, Tooltip } from 'antd';
import MotivosRequest from '../../services/Motivos';
import { openNotification } from '../../util/notificaciones';

class MotivosForm extends Component {
    render() {
        const { visible, onCancel, onCreate, form, isEditing, loading } = this.props;
        const { getFieldDecorator } = form;

        return (
            <Modal
                visible={visible}
                title={isEditing ? "Editar Motivo de Diferencia" : "Agregar Motivo de Diferencia"}
                okText={isEditing ? "Guardar Cambios" : "Agregar"}
                cancelText="Cancelar"
                onCancel={onCancel}
                onOk={onCreate}
                confirmLoading={loading}
                destroyOnClose
            >
                <Form layout="vertical">
                    <Form.Item label="Descripción del Motivo">
                        {getFieldDecorator('descripcion', {
                            rules: [
                                { required: true, message: 'La descripción del motivo es obligatoria.' },
                                {
                                    validator: (rule, value, callback) => {
                                        if (value?.trim().length === 0) {
                                            callback('La descripción no puede estar vacía o contener solo espacios.');
                                        } else {
                                            callback();
                                        }
                                    }
                                }
                            ],
                        })(
                            <Input
                                placeholder="Ingrese la descripción del motivo (ej. Insumo dañado)"
                                maxLength={250}
                                autoFocus
                            />
                        )}
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
}

const MotivoModalForm = Form.create({
    name: 'form_motivo_diferencia',
    mapPropsToFields(props) {
        return {
            descripcion: Form.createFormField({
                value: props.initialValues ? props.initialValues.descripcion : '',
            }),
        };
    },
})(MotivosForm);

export default class Motivos extends Component {
    state = {
        motivos: [],
        loading: false,
        modalVisible: false,
        selectedMotivo: null,
        modalLoading: false,
        pageSize: 10
    };

    componentDidMount() {
        this.obtenerMotivos();
    }

    obtenerMotivos = () => {
        this.setState({ loading: true });
        MotivosRequest.ListarMotivos()
            .then(res => {
                this.setState({
                    motivos: res.data || [],
                    loading: false
                });
            })
            .catch(err => {
                this.setState({ loading: false });
                const msg = err?.response?.data?.message || 'Error al cargar el catálogo de motivos.';
                openNotification(msg, 'Error');
            });
    };

    handleOpenModal = (motivo = null) => {
        this.setState({
            modalVisible: true,
            selectedMotivo: motivo
        });
    };

    handleCloseModal = () => {
        this.setState({
            modalVisible: false,
            selectedMotivo: null
        });
    };

    handleSaveMotivo = () => {
        const { form } = this.formRef.props;
        form.validateFields((err, values) => {
            if (err) return;

            const descripcionLimpia = values.descripcion.trim();
            const { selectedMotivo } = this.state;
            this.setState({ modalLoading: true });

            if (selectedMotivo) {
                MotivosRequest.EditarMotivo(selectedMotivo.id, { descripcion: descripcionLimpia })
                    .then(res => {
                        openNotification('El motivo de diferencia se actualizó correctamente.', 'Éxito');
                        this.setState({ modalLoading: false });
                        this.handleCloseModal();
                        this.obtenerMotivos();
                    })
                    .catch(err => {
                        this.setState({ modalLoading: false });
                        const errors = err?.response?.data?.errors?.descripcion || [];
                        const msg = errors.length > 0 ? errors[0] : (err?.response?.data?.message || 'Error al actualizar el motivo.');
                        openNotification(msg, 'Error');
                    });
            } else {
                MotivosRequest.GuardarMotivo({ descripcion: descripcionLimpia })
                    .then(res => {
                        openNotification('El motivo de diferencia se registró correctamente.', 'Éxito');
                        this.setState({ modalLoading: false });
                        this.handleCloseModal();
                        this.obtenerMotivos();
                    })
                    .catch(err => {
                        this.setState({ modalLoading: false });
                        const errors = err?.response?.data?.errors?.descripcion || [];
                        const msg = errors.length > 0 ? errors[0] : (err?.response?.data?.message || 'Error al registrar el motivo.');
                        openNotification(msg, 'Error');
                    });
            }
        });
    };

    handleDeleteMotivo = (id) => {
        this.setState({ loading: true });
        MotivosRequest.EliminarMotivo(id)
            .then(res => {
                openNotification('El motivo fue eliminado correctamente del catálogo.', 'Éxito');
                this.obtenerMotivos();
            })
            .catch(err => {
                this.setState({ loading: false });
                const msg = err?.response?.data?.message || 'Error al eliminar el motivo.';
                openNotification(msg, 'Error');
            });
    };

    saveFormRef = (formRef) => {
        this.formRef = formRef;
    };

    render() {
        const { motivos, loading, modalVisible, selectedMotivo, modalLoading, pageSize } = this.state;

        const columns = [
            {
                title: 'Descripción del Motivo',
                dataIndex: 'descripcion',
                key: 'descripcion'
            },
            {
                title: 'Acciones',
                key: 'acciones',
                width: 150,
                align: 'center',
                render: (text, record) => (
                    <div>
                        <Tooltip title="Editar Motivo">
                            <Button
                                type="primary"
                                icon="edit"
                                size="small"
                                style={{ marginRight: 8 }}
                                onClick={() => this.handleOpenModal(record)}
                            />
                        </Tooltip>
                        <Tooltip title="Eliminar Motivo">
                            <Popconfirm
                                title="¿Está seguro de eliminar este motivo del catálogo?"
                                onConfirm={() => this.handleDeleteMotivo(record.id)}
                                okText="Sí, eliminar"
                                cancelText="Cancelar"
                                okType="danger"
                            >
                                <Button
                                    type="danger"
                                    icon="delete"
                                    size="small"
                                />
                            </Popconfirm>
                        </Tooltip>
                    </div>
                )
            }
        ];

        return (
            <div>
                <Card
                    title="Motivos de diferencia"
                    extra={
                        <Button
                            type="primary"
                            icon="plus"
                            onClick={() => this.handleOpenModal()}
                        >
                            Agregar Motivo
                        </Button>
                    }
                >
                    <Table
                        columns={columns}
                        dataSource={motivos}
                        rowKey="id"
                        loading={loading}
                        pagination={{
                            pageSize: pageSize,
                            showSizeChanger: true,
                            pageSizeOptions: ['10', '20', '50', '100'],
                            onShowSizeChange: (current, size) => this.setState({ pageSize: size }),
                            showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
                        }}
                        locale={{ emptyText: 'No hay motivos registrados en el catálogo.' }}
                        bordered
                    />
                </Card>

                <MotivoModalForm
                    wrappedComponentRef={this.saveFormRef}
                    visible={modalVisible}
                    isEditing={!!selectedMotivo}
                    loading={modalLoading}
                    onCancel={this.handleCloseModal}
                    onCreate={this.handleSaveMotivo}
                    initialValues={selectedMotivo}
                />
            </div>
        );
    }
}
